import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-245">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-black/80 backdrop-blur-lg border-t border-white/10 z-40 md:hidden" data-id="element-246">
          <a href="#pricing" className="block w-full bg-purple-600 text-white font-bold text-center py-3 rounded-lg shadow-lg active:scale-95 transition-transform" data-id="element-247">
            ACCEDER A LA APP
          </a>
        </motion.div>}
    </AnimatePresence>;
}